module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1b_Image4b.dd282694.jpg";